import { green } from '@ant-design/colors'
import { faRotateLeft } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Alert, Card, ConfigProvider, Form, Input, Space } from 'antd'
import theme from 'antd/lib/theme'
import ThemableButton from '../Items/ThemableButton'
import { useForgotPasswordMutation } from './authenticationQueries'
import './SignIn.css'

const ForgotPassword = () => {
  const forgotPasswordMutation = useForgotPasswordMutation()

  const handleSubmit = (values: any) => {
    forgotPasswordMutation.mutate(values.email)
  }

  const DEFAULT_ERROR_MESSAGE = 'There was a problem sending your reset link. Please try again in a few minutes.'

  return <div className="sign-in-container">
    <Space direction="vertical" size="middle" style={{ maxWidth: 400, padding: 8 }}>
      <img src="/images/synkedup-dark.png" alt="SynkedUP" style={{ maxWidth: '100%' }} />
      {!forgotPasswordMutation.isSuccess && <>
        <ConfigProvider theme={{ algorithm: theme.darkAlgorithm }}>
          <Card style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            Enter your email and we'll send you a password reset link.
          </Card>
        </ConfigProvider>
        <Form onFinish={handleSubmit} size="large">
          <Form.Item
            rules={[
              { required: true, message: 'Email is required' },
              { type: 'email', message: 'Email is not valid' }
            ]}
            name="email"
          >
            <Input type="email" placeholder="Email" />
          </Form.Item>
          <Form.Item hidden={!forgotPasswordMutation.isError}>
            <Alert message={(forgotPasswordMutation.error as Error)?.message || DEFAULT_ERROR_MESSAGE} type="error" showIcon />
          </Form.Item>
          <Form.Item>
            <ThemableButton
              htmlType="submit"
              type="primary"
              colorPrimary={green.primary}
              icon={<FontAwesomeIcon icon={faRotateLeft} />}
              loading={forgotPasswordMutation.isLoading}
            >
              Reset My Password
            </ThemableButton>
          </Form.Item>
        </Form>
      </>}
      {forgotPasswordMutation.isSuccess && <Alert message={forgotPasswordMutation.data as string} type="success" showIcon />}
    </Space>
  </div>
}

export default ForgotPassword
